<template>
  <div class="column-boxes-wrapper">
    <div v-for="column in columns" :key="column.id" class="column-item">
      <h2 class="column-title">
        {{ column.title }} <br/>
        <span class="column-title-secondary">{{ column.titleSecondary }}</span>.
      </h2>

      <p class="column-text">{{ column.text }}</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "ColumnBoxes",
  props: {
    columns: {
      type: Array,
      required: true
    }
  }
}
</script>

<style scoped lang="scss">
@import "~@/assets/css/base.mixins";
@import "~@/assets/css/base.variables";
@import "~@/assets/css/base.fonts";

.column-boxes-wrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 0 80px;
}

// Title
.column-title {
  font-size: 28px;
  font-weight: 900;
  letter-spacing: 0.5px;
  margin-bottom: 15px;

  &-secondary {
    @extend .italic-text;
    font-size: 20px;
    font-weight: 400;
    margin-bottom: 25px;

  }
}

// Text
.column-text {
  @extend .lato-gray;
  font-size: 16px;
  margin-bottom: 25px;
  text-align: justify;
}

@media screen and (min-width: $screen-sm) {
  .column-boxes-wrapper {
    flex-direction: row;
    gap: 0 30px;

    .column-item {
      flex-basis: 50%;
    }
  }
}

@media screen and (min-width: $screen-md) {
  .column-boxes-wrapper {
    gap: 0 40px;
    padding: 0 80px;

    .column-item {
      flex-basis: 35%;
    }
  }


  // Title
  .column-title {
    font-size: 32px;
    margin-bottom: 15px;

    &-secondary {
      font-size: 24px;
      margin-bottom: 25px;

    }
  }

  // Text
  .column-text {
    font-size: 18px;
    margin-bottom: 25px;
  }
}
</style>
